var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("settings.users.userNew")))]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c(
          "v-tabs",
          { attrs: { centered: "", "icons-and-text": "" } },
          [
            _c(
              "v-tab",
              { key: "general" },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("settings.users.personalData")) + " "
                ),
                _c("v-icon", [_vm._v("account_box")])
              ],
              1
            ),
            _c(
              "v-tab-item",
              { key: "general" },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            attrs: { "lazy-validation": "" },
                            model: {
                              value: _vm.formValid,
                              callback: function($$v) {
                                _vm.formValid = $$v
                              },
                              expression: "formValid"
                            }
                          },
                          [
                            _c(
                              "v-radio-group",
                              {
                                attrs: { mandatory: false, row: "" },
                                model: {
                                  value: _vm.users.sex,
                                  callback: function($$v) {
                                    _vm.$set(_vm.users, "sex", $$v)
                                  },
                                  expression: "users.sex"
                                }
                              },
                              [
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.mr"),
                                    value: 1
                                  }
                                }),
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.ms"),
                                    value: 2
                                  }
                                }),
                                _c("v-radio", {
                                  attrs: {
                                    label: _vm.$t("global.notSet"),
                                    value: 0
                                  }
                                })
                              ],
                              1
                            ),
                            _c("v-text-field", {
                              attrs: {
                                label:
                                  _vm.$t("settings.users.fields.name.name") +
                                  "*",
                                rules: _vm.users.nameRules
                              },
                              model: {
                                value: _vm.users.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "name", $$v)
                                },
                                expression: "users.name"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label:
                                  _vm.$t("settings.users.fields.surname.name") +
                                  "*",
                                rules: _vm.users.surnameRules
                              },
                              model: {
                                value: _vm.users.surname,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "surname", $$v)
                                },
                                expression: "users.surname"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label:
                                  _vm.$t("settings.users.fields.login.name") +
                                  "*",
                                rules: _vm.loginValidator
                              },
                              model: {
                                value: _vm.users.login,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "login", $$v)
                                },
                                expression: "users.login"
                              }
                            }),
                            _c("v-text-field", {
                              attrs: {
                                label:
                                  _vm.$t("settings.users.fields.email.name") +
                                  "*",
                                rules: _vm.users.emailRules
                              },
                              model: {
                                value: _vm.users.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "email", $$v)
                                },
                                expression: "users.email"
                              }
                            }),
                            _c("v-checkbox", {
                              attrs: {
                                label: _vm.$t("settings.users.passwordByEmail")
                              },
                              model: {
                                value: _vm.passwordByMail,
                                callback: function($$v) {
                                  _vm.passwordByMail = $$v
                                },
                                expression: "passwordByMail"
                              }
                            }),
                            _c("v-text-field", {
                              ref: "passwordInput",
                              attrs: {
                                label:
                                  _vm.$t(
                                    "settings.users.fields.password.name"
                                  ) + "*",
                                placeholder:
                                  _vm.users.id != null
                                    ? _vm.$t(
                                        "settings.users.fields.password.noChange"
                                      )
                                    : "",
                                rules: _vm.passwordRules,
                                password: "",
                                disabled: _vm.users.password_by_mail,
                                type: "password"
                              },
                              model: {
                                value: _vm.users.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "password", $$v)
                                },
                                expression: "users.password"
                              }
                            }),
                            _c("v-text-field", {
                              ref: "passwordInputRepeat",
                              attrs: {
                                label:
                                  _vm.$t(
                                    "settings.users.fields.repeatPassword.name"
                                  ) + "*",
                                placeholder:
                                  _vm.users.id != null
                                    ? _vm.$t(
                                        "settings.users.fields.repeatPassword.noChange"
                                      )
                                    : "",
                                rules: _vm.users.repeatPasswordRules,
                                disabled: _vm.users.password_by_mail,
                                password: "",
                                type: "password"
                              },
                              model: {
                                value: _vm.users.repeatPassword,
                                callback: function($$v) {
                                  _vm.$set(_vm.users, "repeatPassword", $$v)
                                },
                                expression: "users.repeatPassword"
                              }
                            }),
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_travel_service_enabled === 2 ||
                            _vm.$store.getters["userProperties"].system_settings
                              .is_module_delegation_enabled === 2
                              ? [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.users.fields.integrationIdentifier.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.users.integration_identifier,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.users,
                                          "integration_identifier",
                                          $$v
                                        )
                                      },
                                      expression: "users.integration_identifier"
                                    }
                                  }),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.availableSuperiors,
                                      label: _vm.$t(
                                        "settings.users.fields.superiorUser.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.users.superior_user_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.users,
                                          "superior_user_id",
                                          $$v
                                        )
                                      },
                                      expression: "users.superior_user_id"
                                    }
                                  }),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items:
                                        _vm.availableOrganisationStructures,
                                      label: _vm.$t(
                                        "settings.users.fields.organizationStructure.name"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.users.organization_structure_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.users,
                                          "organization_structure_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "users.organization_structure_id"
                                    }
                                  }),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.availablePrivateVehicles,
                                      label: _vm.$t(
                                        "settings.users.fields.privateVehicle.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.users.vehicle_private_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.users,
                                          "vehicle_private_id",
                                          $$v
                                        )
                                      },
                                      expression: "users.vehicle_private_id"
                                    }
                                  }),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.availableDefaultVehicles,
                                      label: _vm.$t(
                                        "settings.users.fields.defaultVehicle.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.users.vehicle_default_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.users,
                                          "vehicle_default_id",
                                          $$v
                                        )
                                      },
                                      expression: "users.vehicle_default_id"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.users.fields.bankName.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.users.bank_name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.users, "bank_name", $$v)
                                      },
                                      expression: "users.bank_name"
                                    }
                                  }),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.users.fields.bankAccount.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.users.bank_account_number,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.users,
                                          "bank_account_number",
                                          $$v
                                        )
                                      },
                                      expression: "users.bank_account_number"
                                    }
                                  }),
                                  _c("location-ajax-select", {
                                    attrs: {
                                      label: _vm.$t("global.homeLocation"),
                                      placeholder: _vm.users.home_address_name,
                                      "select-model": _vm.users.home_address_id
                                    },
                                    on: {
                                      "update:selectModel": function($event) {
                                        return _vm.$set(
                                          _vm.users,
                                          "home_address_id",
                                          $event
                                        )
                                      },
                                      "update:select-model": function($event) {
                                        return _vm.$set(
                                          _vm.users,
                                          "home_address_id",
                                          $event
                                        )
                                      }
                                    }
                                  }),
                                  _c("location-ajax-select", {
                                    attrs: {
                                      label: _vm.$t("global.workLocation"),
                                      placeholder: _vm.users.work_address_name,
                                      "select-model": _vm.users.work_address_id
                                    },
                                    on: {
                                      "update:selectModel": function($event) {
                                        return _vm.$set(
                                          _vm.users,
                                          "work_address_id",
                                          $event
                                        )
                                      },
                                      "update:select-model": function($event) {
                                        return _vm.$set(
                                          _vm.users,
                                          "work_address_id",
                                          $event
                                        )
                                      }
                                    }
                                  }),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      clearable: true,
                                      items: _vm.availableDelegationGroups,
                                      label: _vm.$t(
                                        "settings.users.fields.delegationRateGroup.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.users.group_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.users, "group_id", $$v)
                                      },
                                      expression: "users.group_id"
                                    }
                                  }),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.languageChooser,
                                      label: _vm.$t(
                                        "settings.users.fields.language.name"
                                      )
                                    },
                                    model: {
                                      value: _vm.users.language,
                                      callback: function($$v) {
                                        _vm.$set(_vm.users, "language", $$v)
                                      },
                                      expression: "users.language"
                                    }
                                  }),
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "settings.users.basicData.fields.isNotifyNewTravelServiceResponse.name"
                                      )
                                    },
                                    model: {
                                      value:
                                        _vm.users
                                          .is_notify_new_travel_service_response,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.users,
                                          "is_notify_new_travel_service_response",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "users.is_notify_new_travel_service_response"
                                    }
                                  })
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled:
                        !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                      color: "blue darken-1",
                      text: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.add")) + " ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }